import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ExternalLinkIcon, OutlinedInfoIcon, PlusIconPlain, PopupList, TitleAndDescription, } from '@streamr/tv-ui';
import cx from 'classnames';
import styled from 'styled-components';
import { MERCHANT_DASHBOARD_LOGIN_URL } from '../../../consts';
import { PurchaseService } from '../../../services/purchase/PurchaseService';
import { BottomRight, Popup, TopRight } from '../../../utils/popups';
import { AbstractPopup } from '../AbstractPopup';
import { PopupCssPreset } from '../Popup.styles';
import { showTermsOfServicePopup } from '../TermsOfServicePopup';
import { showMerchantOnboardingPopup } from './MerchantOnboardingPopup';
import { showMerchantSelectionPopup } from './MerchantSelectionPopup';
const AudienceContributionsSettingsPopup = ({ reject, resolve, variant, ...props }) => {
    const productsOfActiveBroadcast = PurchaseService.getOutput().useProductsOfActiveBroadcast();
    return (_jsx(AudienceContributionsSettingsPopupRoot, { reject: reject, translateFn: variant === 'top-right' ? BottomRight : TopRight, ...props, className: cx(props.className, variant), children: _jsxs(ContentRoot, { children: [_jsx(HeaderContainer, { children: _jsx(Title, { children: "Audience contributions" }) }), productsOfActiveBroadcast.length > 0 && (_jsx(MerchantsDescription, { children: "The products of the following merchants will be available in this broadcast." })), _jsxs(StyledPopupList, { children: [productsOfActiveBroadcast.map((product) => (_jsx(MerchantContainer, { children: _jsx(TitleAndDescription, { title: product.name, description: "" // TODO
                             }) }, product.merchantId))), _jsx(AddAccountButton, { onClick: () => {
                                reject();
                                showMerchantSelectionPopup({
                                    anchorRef: props.anchorRef,
                                    variant,
                                });
                            }, children: _jsx(TitleAndDescription, { title: "Add a merchant to the broadcast", avatar: _jsx(AddAccountButtonIcon, { children: _jsx(PlusIconPlain, {}) }) }) }, "addMerchantAccount")] }), _jsx(Separator, {}), _jsxs(StyledPopupList, { children: [_jsxs(AccountButton, { type: "button", onClick: () => {
                                reject();
                                showMerchantOnboardingPopup({
                                    anchorRef: props.anchorRef,
                                });
                            }, children: [_jsx("span", { children: "Create your own merchant account" }), _jsx(PlusIconPlain, {})] }), _jsxs(AccountButton, { tag: "a", href: MERCHANT_DASHBOARD_LOGIN_URL, target: "_blank", children: [_jsx("span", { children: "Go to your merchant dashboard" }), _jsx(ExternalLinkIcon, {})] }), _jsxs(AccountButton, { type: "button", onClick: () => {
                                reject();
                                showTermsOfServicePopup({
                                    anchorRef: props.anchorRef,
                                    mode: 'informative',
                                });
                            }, children: [_jsx("span", { children: "Terms of service" }), _jsx(OutlinedInfoIcon, {})] })] })] }) }));
};
const AudienceContributionsSettingsPopupRoot = styled(AbstractPopup) `
    ${PopupCssPreset.Center};
    --Popup_Padding: 1.5rem;
    --Popup_Width: 90vw;

    @media (min-width: 30rem) {
        --Popup_Width: 25rem;

        &.top-right {
            ${PopupCssPreset.AnchoredBottomRight};
        }

        &.bottom-right {
            ${PopupCssPreset.AnchoredTopRight};
        }
    }
`;
const StyledPopupList = styled(PopupList) `
    --PopupListItem_Padding: 0;
`;
const MerchantContainer = styled.div `
    padding: 1rem;
`;
const ContentRoot = styled.div `
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;
const HeaderContainer = styled.div `
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
const Title = styled.span `
    font-size: 1.125rem;
    font-weight: 500;
    line-height: 1.5rem;
    display: block;
`;
const MerchantsDescription = styled.p `
    font-size: 0.875rem;
    color: var(--tv-ui-color-8);
    margin-bottom: 0;
`;
const Separator = styled.div `
    width: 100%;
    height: 1px;
    background-color: var(--tv-ui-color-5);
`;
const AddAccountButton = styled(Button) `
    width: 100%;
    text-align: left;
    display: block;
    white-space: normal;
    --Button_Padding: 1rem;
    --Button_HoverTransform: 0;
    --Button_ActiveTransform: 0;
`;
const AddAccountButtonIcon = styled.div `
    width: 2rem;
    height: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--tv-ui-color-3);
    background-color: var(--tv-ui-color-7);
`;
const AccountButton = styled(Button) `
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: normal;
    text-align: left;
    gap: 0.5rem;
    box-sizing: border-box;
    line-height: normal;
    --Button_Padding: 1rem;
    --Button_HoverTransform: 0;
    --Button_ActiveTransform: 0;
`;
const audienceContributionsSettingsPopup = Popup.create(AudienceContributionsSettingsPopup);
export function showAudienceContributionsSettingsPopup(options) {
    (async () => {
        try {
            options.onOpenPopup?.();
            await audienceContributionsSettingsPopup.pop({
                anchorRef: options.anchorRef,
                variant: options.variant,
            });
        }
        catch (_ignore) {
        }
        finally {
            options.onClosePopup?.();
        }
    })();
}
